import React, { FC } from 'react';
import Truncate from 'react-truncate';

import ImgixWrapper from '@common/components/ImgixWrapper';
import { Link } from 'shared-routing';
import { DiscountBanner, FromPrice } from '../Price';
import { SpaItemsGridProps } from './SpaItemsGrid.types';
import {
  ITEM_MARGIN,
  SpaItem,
  SpaItemsGridWrapper,
  ImagePlaceholder,
  SpaItemName,
  ImageWrapper,
} from './SpaItemsGrid.styles';

export const SpaItemsGrid: FC<SpaItemsGridProps> = ({ items = [], columns = 4, route }) => {
  const imageAspectRatio = 2 / 3;
  const initialWidth = 1440 / columns - 2 * ITEM_MARGIN;
  const initialHeight = Math.floor(initialWidth * imageAspectRatio);

  return (
    <SpaItemsGridWrapper>
      {items.map((item) => (
        <SpaItem columns={columns} key={item.id}>
          <Link route={route} params={{ id: item.id }}>
            {item.image ? (
              <ImageWrapper>
                <DiscountBanner discount={item.discount} />
                <ImgixWrapper
                  src={item.image.url}
                  width={initialWidth}
                  height={initialHeight}
                  sizes="auto"
                  imgixParams={{
                    ar: '2:3',
                  }}
                  alt={item.name}
                />
              </ImageWrapper>
            ) : (
              <ImagePlaceholder ratio={imageAspectRatio} />
            )}
            <SpaItemName>
              <Truncate trimWhitespace lines={2}>
                {item.name}
              </Truncate>
            </SpaItemName>
            <FromPrice price={item.price} discount={item.discount} />
          </Link>
        </SpaItem>
      ))}
    </SpaItemsGridWrapper>
  );
};
